import { createActionCreator, sleep, paramsEncode } from '../../utils/';
import request from '../../utils/request';
import constant from './constant';
import Urls from '../../../config/index';
import { createLoadingAction} from "../index/actions";

const loginUrl = Urls.LoginUrl.login;
const logoutUrl = Urls.LoginUrl.logout;

export const createLoginAction = createActionCreator(constant.LOGIN, userInfo => userInfo);
export const createLogoutAction = createActionCreator(constant.LOGOUT, userInfo => userInfo);
export const createIsAuthenticatedAction = createActionCreator(constant.isAuthenticated, b => b);
export const createRedirectToReferrerAction = createActionCreator(constant.redirectToReferrer, b => b);
export const createDutyAction = createActionCreator(constant.GETDUTY, userInfo => userInfo);

export const login = (name, password,code) => {
    return async (dispatch, getState) => {
        try {
            let response = await request(loginUrl, 'POST', Object.assign({}, { name: name }, { password: password },{code:code}));
            dispatch(createLoginAction(response));
            dispatch(createIsAuthenticatedAction(true));
        } catch (e) {
            alert(e.message)
        }
    }
}

export const logout = () => {
    return async (dispatch, getState) => {
        try {
            let result = await request(logoutUrl);
            console.log(result)
            dispatch(createLogoutAction());
            dispatch(createIsAuthenticatedAction(false));
        } catch (e) {
            console.log(e);
        }
    }
}

export const getDuty = () => {
    return async (dispatch, getState) => {
        try {

            let result = await request(Urls.LoginUrl.getDuty);


            dispatch(createDutyAction(result));

        } catch (e) {
            console.log(e);
        }
    }
}



// WEBPACK FOOTER //
// ./pages/login/actions.js